// extracted by mini-css-extract-plugin
export default {"Root":"MarkdownView_Root__E2Awr","TableWrapper":"MarkdownView_TableWrapper__ddiOy","Table":"MarkdownView_Table__WKYxf"};